import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

/** Readable names for the audit actions the app writes. Unknown actions show their raw name. */
export function auditActionLabels(): Readonly<Record<string, MessageDescriptor>> {
  return {
    "user.it_granted": msg`IT access granted`,
    "user.it_revoked": msg`IT access revoked`,
    "user.blocked": msg`User blocked`,
    "user.unblocked": msg`User unblocked`,
    "template.published": msg`Template published`,
    "template.version_published": msg`Template version published`,
    "template.archived": msg`Template archived`,
    "assignment.assigned": msg`Template assigned`,
    "assignment.unassigned": msg`Template unassigned`,
    "copy.pushed": msg`Copy pushed`,
    "copy.push_failed": msg`Copy push failed`,
    "company_model.created": msg`Company model provider added`,
    "company_model.updated": msg`Company model provider updated`,
    "company_model.removed": msg`Company model provider removed`,
    "company_model.enabled": msg`Company model provider enabled`,
    "company_model.disabled": msg`Company model provider disabled`,
  };
}
